import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildUrl } from '../services/api';

export const useSubscriptionGuard = (redirectPath = '/plan-selection') => {
    const navigate = useNavigate();
    const [isSubscriptionValid, setIsSubscriptionValid] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [subscriptionData, setSubscriptionData] = useState(null);

    useEffect(() => {
        const checkSubscription = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    navigate('/login');
                    return;
                }

                const response = await fetch(buildUrl('/subscription/'), {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    const subData = await response.json();
                    console.log('🔒 Subscription guard check:', subData);
                    
                    // Normalize and broaden acceptable states
                    const normalizedStatus = (subData?.subscription_status || '').toLowerCase();
                    const planType = (subData?.plan_type || '').toLowerCase();
                    // Consider trialing as valid; accept any non-empty plan type
                    const hasActivePlan = (normalizedStatus === 'active' || normalizedStatus === 'trialing') && !!planType;
                    
                    if (!hasActivePlan) {
                        console.log('❌ Subscription guard: No active subscription, redirecting to', redirectPath);
                        navigate(redirectPath);
                        return;
                    }
                    
                    console.log('✅ Subscription guard: Active subscription found:', subData?.plan_type);
                    setSubscriptionData(subData);
                    setIsSubscriptionValid(true);
                } else {
                    console.log('❌ Subscription guard: Failed to fetch subscription, redirecting to', redirectPath);
                    navigate(redirectPath);
                }
            } catch (error) {
                console.error('Subscription guard error:', error);
                navigate(redirectPath);
            } finally {
                setIsLoading(false);
            }
        };

        checkSubscription();
    }, [navigate, redirectPath]);

    return {
        isSubscriptionValid,
        isLoading,
        subscriptionData
    };
};

export default useSubscriptionGuard;
